export default "__VITE_ASSET__8600beb7__"